/**
 * @file This file contains methods used for translation purposes
 */
import { n__, __ } from 'bits/intl'
import { Component, Vue } from 'vue-property-decorator'
import t from 'vuedirectives/t'

/**
 * Declared same mixin as component to use with Mixins helper function
 * in vue class style components
 */
@Component({
  directives: { t },
  filters: { __: __ },
})
export class IntlMixin extends Vue {
  __(phrase: string, args?: object): string {
    return __(phrase, args)
  }

  n__(singularPhrase: string, pluralPhrase: string, num: number, args: object): string {
    return n__(singularPhrase, pluralPhrase, num, args)
  }
}

export default {
  directives: { t },
  filters: {
    __: __,
  },
  methods: {
    __: __,
    n__: n__,
  },
}
